import React from 'react';
import './IconButton.css';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'neutral' | 'amber';
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ tone = 'neutral', className = '', type = 'button', ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={`a-icon-btn a-icon-btn--${tone} ${className}`.trim()}
      {...rest}
    />
  )
);
IconButton.displayName = 'IconButton';
